import { Types } from '../actions/types'
import initialState from '../store/initial.state'

export const loginDataReducer = (
  state = initialState.loginDataReducer,
  action
) => {
  switch (action.type) {
    case Types.LOGIN_DATA: {
      let data = action.payload
      return {
        ...state,
        loginData: {
          ...state.loginData,
          ...data,
        },
      }
    }
    default:
      return state
  }
}
